module.exports = __webpack_public_path__ + "static/media/335.5372c900.svg";